module.exports = __webpack_public_path__ + "img/scor.e7d215ad.gif";